import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sites: {
    list: [],
    totalEntries: null,
  },
};

export const globalOptions = createSlice({
  name: 'global',
  initialState,
  reducers: {
    fetchGlobalSitesList() {
      // action only for saga
    },
    setGlobalSitesList: (state, { payload }) => {
      // the payload has list of sites and total entries
      state.sites.list = payload.list;
      state.totalEntries = payload.totalEntries;
    },
  },
});

export const { actions, reducer } = globalOptions;
